import { QueueWaitOfferType } from '.';
import { VoiceMessageBuilder } from '../..';
import { callbackUserInputOptionBuilder } from '..';
var QueueWaitOfferBuilder = /** @class */ (function () {
    function QueueWaitOfferBuilder() {
        this.queueOffer = {
            queueWaitOfferType: QueueWaitOfferType.CALLBACK,
            userInputOption: callbackUserInputOptionBuilder({ messages: [new VoiceMessageBuilder().build()] })
        };
    }
    QueueWaitOfferBuilder.prototype.withQueueWaitOfferType = function (queueWaitOfferType) {
        this.queueOffer.queueWaitOfferType = queueWaitOfferType;
        return this;
    };
    QueueWaitOfferBuilder.prototype.withUserInputOption = function (userInputOption) {
        this.queueOffer.userInputOption = userInputOption;
        return this;
    };
    QueueWaitOfferBuilder.prototype.build = function () {
        return this.queueOffer;
    };
    return QueueWaitOfferBuilder;
}());
export { QueueWaitOfferBuilder };
//# sourceMappingURL=queue-wait-offer.builder.js.map